import { DataFieldTypes } from '@app/enums/data-field-types.enum';
import { DataValue } from '@app/models/employee/data-value.model';
import { DataField } from '@app/models/settings/data-field.model';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { LimitToPipe } from '@app/pipes';

export class FieldValueColumn extends Column {
    title: string;
    sortable = false;
    type: CellDisplay = CellDisplay.string;
    limitToPipe = new LimitToPipe();

    constructor(protected dataField: DataField) {
        super();

        this.title = dataField?.name ?? 'Field Value';
    }

    getRowStyling(dataValue: DataValue): { [key: string]: string } | null {
        if (!dataValue.value) {
            return { color: 'var(--grey-700)', 'font-style': 'italic' };
        }
    }

    getDisplayPropertyValue(dataValue: DataValue): string {
        const longTextType = this.dataField.type === DataFieldTypes.longText;

        if (!dataValue.value) {
            return 'Empty';
        }

        if (longTextType) {
            const textCharacterLimit = 75;
            return this.limitToPipe.transform(dataValue.displayValue, textCharacterLimit);
        }

        return dataValue.displayValue;
    }
}
